var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid p-fluid dashboard"},_vm._l((_vm.wagonsPerRail),function(rail){return _c('div',{key:rail.id,staticClass:"p-col-12 p-md-4 p-xl-2"},[_c('rails-panel',{attrs:{"title":rail.label,"wagons":rail.wagons}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }